import axios from "axios";
import { getUrl } from "./api";
import { SignInForm, SignUpForm, RecoverForm } from "../interfaces/auth";

export const TOKEN_KEY = "@passage-van-t";
export const WELCOME = "@passage-van-welcome";

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const isWelcome = () => localStorage.getItem(WELCOME) !== null;

export const login = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const setWelcome = (value = "ok") => {
  localStorage.setItem(WELCOME, value);
};

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const onSignIn = async (fields: SignInForm) => {
  return axios.post(`${getUrl()}/auth/sign-in`, fields);
};

export const onSignInFacebook = async (token: string) => {
  return axios.post(`${getUrl()}/auth/sign-in-facebook`, {
    token,
  });
};

export const onSignUp = async (fields: SignUpForm) => {
  return axios.post(`${getUrl()}/auth/sign-up`, fields);
};

export const onRecover = async (fields: RecoverForm) => {
  return axios.post(`${getUrl()}/auth/recover/pass`, fields);
};
